export const BASE_URL = "https://us-central1-zeylon-life-dev0.cloudfunctions.net/api";
//export const BASE_URL = "http://localhost:3000";